import type { GridOptions } from '../../../components/ui/table';
import { commonGridOptions, commonTextFilterParams } from '../../../lib/agGridOptions';
import {
  GRID_PAGE_SIZE,
  GRID_PAGE_SIZE_SELECTOR,
} from '../../../components/shared/agGridCells';
import type { RoutingRule, RoutingSimulationStep } from '../models/types';

export { GRID_PAGE_SIZE, GRID_PAGE_SIZE_SELECTOR };

export const ROUTING_GRID_DEFAULT_COL_DEF = {
  suppressAutoSize: true,
  filterParams: {
    ...commonTextFilterParams,
    filterOptions: ['contains'],
  },
};

export const routingRuleGridOptions = {
  ...commonGridOptions,
  suppressRowClickSelection: true,
  overlayNoRowsTemplate:
    '<span class="text-sm text-muted-foreground">No routing rules match the current filters.</span>',
} satisfies GridOptions<RoutingRule>;

export const simulationStepGridOptions = {
  ...commonGridOptions,
  suppressRowClickSelection: true,
  overlayNoRowsTemplate:
    '<span class="text-sm text-muted-foreground">Run a simulation to see group evaluation steps.</span>',
} satisfies GridOptions<RoutingSimulationStep>;
